import style from './Footer.module.css';

const Footer = ({className=""}) => {

  return (
    <div className={`${style.footer} ${className}`}>
      Desenvolvido por: Ape Solutions
    </div>
  );
};

export default Footer;
